/* src/app/modules/user/partnersequity/reserve/reserve-list.component.css */
/*# sourceMappingURL=reserve-list.component.css.map */
